<template>
  <v-layout>
    <v-container fluid>
      <v-row><h1>Dashboard</h1></v-row>
      <v-row><div id="containerDashboard"></div></v-row>
    </v-container>
  </v-layout>
</template>

<script>
import * as pbi from 'powerbi-client'

export default {
  name: 'Dashboard',

  data: () => ({
    reportAccessToken: '',
    reportEmbedUrl: '',
    customerFilterValues: [],
    groupFilterValues: [],
    nmiFilterValues: [],
    reportSection: '',
  }),
  mounted() {
    this.renderReport()
  },
  methods: {
    filter(event) {
      if (event) {
        this.renderReport()
      }
    },
    renderReport() {
      if (this.$store.state.accessToken == null) {
        this.$store.dispatch('updateAccessToken', this.$auth.authStateManager._authState.accessToken.value)
      }
      const reportFiltersResponse = this.$api.powerBIReport.getPowerBIReportFilters(
        'DASHBOARD',
        this.$store.state.accessToken
      )
      reportFiltersResponse.then(reportFiltersResponse => {
        this.customerFilterValues = reportFiltersResponse.data.customers
        this.groupFilterValues = reportFiltersResponse.data.groups
        this.nmiFilterValues = reportFiltersResponse.data.nmis
        this.reportSection = reportFiltersResponse.data.reportSection

        const embedUrlResponse = this.$api.powerBIReport.getPowerBIReport('DASHBOARD', this.$store.state.accessToken)
        embedUrlResponse.then(embedUrlResponse => {
          this.reportAccessToken = embedUrlResponse.data.embedToken

          this.reportEmbedUrl = embedUrlResponse.data.embedReports[0].embedUrl

          const customerIdFilter = (pbi.models.IBasicFilter = {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'Dimension Tenant',
              column: 'TenantBK',
            },
            operator: 'In',
            values: this.customerFilterValues,
            filterType: 1,
            displaySettings: {
              isLockedInViewMode: true,
              isHiddenInViewMode: true,
            },
          })

          const groupFilter = (pbi.models.IBasicFilter = {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'Dimension Site',
              column: 'Site Group',
            },
            operator: 'In',
            values: this.groupFilterValues,
            filterType: 1,
            displaySettings: {
              isLockedInViewMode: true,
              isHiddenInViewMode: true,
            },
          })

          const nmiFilter = (pbi.models.IBasicFilter = {
            $schema: 'http://powerbi.com/product/schema#basic',
            target: {
              table: 'Dimension Site',
              column: 'Extra Site Identifier',
            },
            operator: 'In',
            values: this.nmiFilterValues,
            filterType: 1,
            displaySettings: {
              isLockedInViewMode: true,
              isHiddenInViewMode: true,
            },
          })

          let config = {
            type: 'report',
            tokenType: pbi.models.TokenType.Embed,
            accessToken: this.reportAccessToken,
            embedUrl: this.reportEmbedUrl,
            filters: [customerIdFilter, groupFilter, nmiFilter],
            settings: {
              background: pbi.models.BackgroundType.Transparent,
              navContentPaneEnabled: false,
              filterPaneEnabled: false,
              commands: [
                {
                  includeExclude: {
                    displayOption: 2,
                  },
                },
              ],
              bookmarks: {
                visible: false,
              },
              fields: {
                expanded: false,
              },
              filters: {
                expanded: false,
                visible: true,
              },
              pageNavigation: {
                visible: false,
              },
              selection: {
                visible: false,
              },
              syncSlicers: {
                visible: false,
              },
              visualizations: {
                expanded: false,
              },
            },
            pageName: this.reportSection,
          }

          let powerbi = new pbi.service.Service(
            pbi.factories.hpmFactory,
            pbi.factories.wpmpFactory,
            pbi.factories.routerFactory
          )
          let reportContainer = document.getElementById('containerDashboard')
          powerbi.reset(reportContainer)
          let report = powerbi.embed(reportContainer, config)

          report.off('loaded')

          report.off('rendered')

          report.on('error', function () {
            this.report.off('error')
          })
        })
      })
    },
  },
}
</script>

<style scoped>
#containerDashboard {
  width: 100vw;
  height: 100vh;
  padding: 5px;
}
</style>
